export default {"src":"/_next/static/media/desmos-geometry.bbfdbadd.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};